import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';

export const useNewPresentationId = () => {
  const { mutate: createPresentationId } = useMutation(
    async (_: { onSuccess: (id: string) => void }) => {
      return await BackendService.instance.presentations.newPresentationId();
    },
    {
      onSuccess: (data, arg) => {
        arg.onSuccess(data.id);
      },
    },
  );

  return {
    createPresentationId,
  };
};
